/*
  http://cf.everpoint.ru/pages/viewpage.action?pageId=45024217
 */

export const SYMBOL_LIMITS = {
  SIZE_MIN: 1,
  SIZE_MAX: 64,
  SIZE_STEP: 1,
  GRID_SIZE_MIN: 0.1,
  GRID_SIZE_MAX: 120,
  MIN_OBJECTS_COUNT: 2,
  MAX_OBJECTS_COUNT: 10000,
  MIN_CLUSTER_SIZE: 16,
  MAX_CLUSTER_SIZE: 120,
  STROKE_WIDTH_MIN: 0,
  STROKE_WIDTH_MAX: 32,
  STROKE_WIDTH_STEP: 0.25,
  ANGLE_MIN: -360,
  ANGLE_MAX: 360,
  ANGLE_STEP: 1,
  PREVIEW_SIZE_MAX: 32,
  PREVIEW_SIZE_MAX_WIDTH: 26,
};

export enum LABEL_LIMITS {
  SIZE_MIN = 6,
  SIZE_MAX = 48,
  HALO_MIN = 0,
  HALO_MAX = 24,
  ROUNDING_MIN = 0,
  ROUNDING_MAX = 96,
  ROUNDING_STEP = 0.5,
  STROKE_WIDTH_MIN = 0,
  STROKE_WIDTH_MAX = 32,
  STROKE_WIDTH_STEP = 0.25,
  BACKGROUND_OFFSET_MIN = 1,
  BACKGROUND_OFFSET_MAX = 24,
  BACKGROUND_OFFSET_STEP = 1,
}
